export default __webpack_public_path__ + "static/media/continue.4750a901.svg";